import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.applicants');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-applicants',
template: templateSource || '',
    styles: [``],
})
export class PageApplicantsComponent implements OnInit {
    public loading: boolean = true;
    public uploading: boolean = false;
    public exporting: boolean = false;
    public googleExporting: boolean = false;
    public applicants: any[] = [];
    public recruitments: any[] = [];
    public exportJobs: any[] = [];
    public searchWarnings: string[] = [];
    public searchErrors: string[] = [];
    public searchPagination: any = {
        page: 1,
        limit: 25,
        total: 0,
        has_more: false
    };
    public searchRateLimit: any = {
        remaining: null,
        window_seconds: 60,
        identity_type: "actor_id"
    };
    public searchPermissions: any = {
        can_search: false,
        can_search_sensitive: false,
        can_open_detail: false,
        can_open_blind: false,
        can_upload_applicant: false,
        can_export: false
    };
    public exportPermissions: any = {
        can_create_limited: false,
        can_google_placeholder: false,
        can_download: false,
        can_admin_masked: false,
        limited_status_label: "권한 확인 중",
        download_status_label: "권한 확인 중",
        admin_masked_status_label: "관리자 승인 기능 전까지 비활성",
        google_sheets_status_label: "관리자 승인 및 연동 설정 후 사용 가능"
    };
    public selectedFile: any = null;
    public dragActive: boolean = false;
    public uploadProgress: number = 0;
    public uploadByteProgress: number = 0;
    public uploadState: string = "";
    public uploadMessage: string = "";
    public uploadModalOpen: boolean = false;
    public uploadModalCanClose: boolean = false;
    public uploadModalError: string = "";
    public uploadStageLabel: string = "";
    public uploadModalFileName: string = "";
    public uploadModalFileSize: string = "";
    public uploadPolicy: any = {
        max_upload_mb: 100,
        max_upload_bytes: 100 * 1024 * 1024,
        max_bytes: 100 * 1024 * 1024,
        allowed_extensions: [".pdf"],
        allowed_mime_types: ["application/pdf", "application/x-pdf"],
        solo_admin_mode: true,
        ui_policy: {
            solo_admin_mode: true
        }
    };
    public search: any = {
        recruitment_id: "",
        applicant_no: "",
        name: "",
        application_position: "",
        review_status: "",
        birth_date: "",
        limit: 25,
        page: 1
    };

    public reviewStatuses: any[] = [
        { key: "", label: "전체" },
        { key: "NEEDS_HUMAN_REVIEW", label: "확인 필요" },
        { key: "REVIEW_IN_PROGRESS", label: "검토 중" },
        { key: "REVIEW_COMPLETED", label: "검토 완료" },
        { key: "QUEUED", label: "처리 대기" },
    ];
    public positions: any[] = [
        { key: "", label: "전체" },
        { key: "EDUCATION_REGULAR", label: "교육담당 정규직" },
        { key: "ASSISTANT_CONTRACT", label: "업무보조 계약직" },
        { key: "UNKNOWN", label: "미확인" },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadUploadPolicy();
        await this.loadRecruitments();
        await this.loadSearchPermissions();
        await this.load();
    }

    public async loadUploadPolicy() {
        const { code, data } = await wiz.call("upload_policy");
        if (code === 200 && data) this.uploadPolicy = { ...this.uploadPolicy, ...data };
    }

    public async loadRecruitments() {
        const { code, data } = await wiz.call("recruitments");
        if (code === 200) {
            this.recruitments = data || [];
            if (!this.search.recruitment_id && this.recruitments.length > 0) {
                this.search.recruitment_id = this.recruitments[0].id;
            }
        }
    }

    public async loadSearchPermissions() {
        const { code, data } = await wiz.call("search_permissions");
        if (code === 200 && data) this.searchPermissions = data;
        if (!this.searchPermissions.can_search_sensitive) this.search.birth_date = "";
    }

    public canUploadApplicant() {
        return !!this.searchPermissions?.can_upload_applicant;
    }

    public uploadPermissionStatus() {
        return this.canUploadApplicant() ? "available" : "PERMISSION_REQUIRED";
    }

    public uploadPermissionLabel() {
        return this.canUploadApplicant() ? "업로드 가능" : "업로드 권한 필요";
    }

    public uploadButtonLabel() {
        if (!this.canUploadApplicant()) return "업로드 권한 필요";
        if (this.uploading) return "처리 중";
        if (!this.search.recruitment_id) return "전형 선택 필요";
        if (!this.hasSelectedFile()) return "파일 선택 필요";
        return "업로드";
    }

    public uploadDropClass() {
        if (!this.canUploadApplicant()) return "border-zinc-200 bg-zinc-50";
        return this.dragActive ? "border-zinc-900 bg-zinc-50" : "border-zinc-300 bg-white";
    }

    public setUploadPermissionRequiredState() {
        if (this.canUploadApplicant()) return false;
        this.dragActive = false;
        this.selectedFile = null;
        this.uploadState = "PERMISSION_REQUIRED";
        this.uploadMessage = "업로드 권한 필요";
        this.uploadProgress = 0;
        return true;
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("search", this.search);
        if (code === 200) {
            this.applicants = data?.rows || [];
            this.searchWarnings = data?.warnings || [];
            this.searchErrors = data?.errors || [];
            this.searchPagination = data?.pagination || this.searchPagination;
            this.searchRateLimit = data?.rate_limit || this.searchRateLimit;
            if (data?.permissions) this.searchPermissions = data.permissions;
        } else {
            this.applicants = [];
            this.searchWarnings = [];
            this.searchErrors = [message || "검색 권한, 요청 빈도 또는 조건을 확인해주세요."];
        }
        await this.loadExportPermissions();
        if (this.searchPermissions.can_export) {
            await this.loadExports();
        } else {
            this.exportJobs = [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async loadExportPermissions() {
        const { code, data } = await wiz.call("export_permissions");
        if (code === 200 && data) this.exportPermissions = data;
    }

    public async loadExports() {
        if (!this.search.recruitment_id) {
            this.exportJobs = [];
            return;
        }
        const { code, data } = await wiz.call("exports", {
            recruitment_id: this.search.recruitment_id
        });
        if (code === 200) this.exportJobs = data || [];
    }

    public async createXlsxExport() {
        if (!this.search.recruitment_id || this.exporting) return;
        if (!this.searchPermissions.can_export || !this.exportPermissions.can_create_limited) {
            await this.service.modal.error("XLSX 내보내기 권한이 필요합니다.");
            return;
        }

        this.exporting = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("create_xlsx_export", {
            recruitment_id: this.search.recruitment_id,
            export_profile: "limited"
        });
        this.exporting = false;

        if (code === 200) {
            await this.loadExports();
            await this.service.render();
            return data;
        }

        await this.service.modal.error(message || "XLSX 내보내기 생성에 실패했습니다.");
        await this.service.render();
    }

    public async createGoogleSheetsPlaceholder() {
        if (!this.search.recruitment_id || this.googleExporting) return;
        if (!this.exportPermissions.can_google_placeholder) {
            await this.service.modal.error("Google Sheets placeholder 요청 권한이 필요합니다.");
            return;
        }

        this.googleExporting = true;
        await this.service.render();

        const { code, message } = await wiz.call("create_google_sheets_placeholder", {
            recruitment_id: this.search.recruitment_id
        });
        this.googleExporting = false;

        if (code === 200) {
            await this.loadExports();
            await this.service.render();
            return;
        }

        await this.service.modal.error(message || "Google Sheets placeholder 처리에 실패했습니다.");
        await this.service.render();
    }

    public async downloadExport(job: any) {
        if (!job?.download_available) return;
        if (!this.exportPermissions.can_download) {
            await this.service.modal.error("내보내기 파일 다운로드 권한이 필요합니다.");
            return;
        }
        window.location.href = `${wiz.url("download_export")}?id=${encodeURIComponent(job.id)}`;
    }

    public async filterByStatus(status: string) {
        this.search.review_status = status;
        this.search.page = 1;
        await this.load();
    }

    public async submitSearch() {
        this.search.page = 1;
        await this.load();
    }

    public async changePage(delta: number) {
        const next = Math.max(1, Number(this.search.page || 1) + delta);
        if (delta > 0 && !this.searchPagination.has_more) return;
        this.search.page = next;
        await this.load();
    }

    public openResult(item: any) {
        const url = item?.primary_url || item?.detail_url || item?.blind_url;
        if (!url) return;
        location.href = url;
    }

    public async selectFile(event: any, input?: any) {
        if (this.setUploadPermissionRequiredState()) {
            if (event?.target) event.target.value = "";
            await this.service.render();
            return;
        }
        const files = event?.target?.files || [];
        if (this.rejectMultipleFiles(files, input || event?.target)) {
            await this.service.render();
            return;
        }
        this.setSelectedFile(this.firstFile(files), input || event?.target);
        await this.service.render();
    }

    public setSelectedFile(file: any, input?: any) {
        this.uploadState = "";
        this.uploadMessage = "";
        this.uploadProgress = 0;
        this.selectedFile = null;
        if (!file) {
            this.clearFileInput(input);
            return;
        }
        if (!this.isUploadFile(file)) {
            this.uploadState = "failed";
            this.uploadMessage = "선택한 PDF 파일 정보를 확인할 수 없습니다. 파일을 다시 선택해주세요.";
            this.clearFileInput(input);
            return;
        }

        const error = this.validateClientFile(file);
        if (error) {
            this.uploadState = "failed";
            this.uploadMessage = error;
            this.clearFileInput(input);
            return;
        }
        this.selectedFile = file;
        this.clearFileInput(input);
    }

    public handleDragEnter(event: any) {
        this.handleDragOver(event);
    }

    public handleDragOver(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (event?.dataTransfer) event.dataTransfer.dropEffect = this.canUploadApplicant() ? "copy" : "none";
        if (!this.canUploadApplicant()) return;
        this.dragActive = true;
    }

    public handleDragLeave(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragActive = false;
    }

    public async handleDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragActive = false;
        if (this.setUploadPermissionRequiredState()) {
            await this.service.render();
            return;
        }
        const files = event?.dataTransfer?.files || [];
        if (this.rejectMultipleFiles(files)) {
            await this.service.render();
            return;
        }
        this.setSelectedFile(this.firstFile(files));
        await this.service.render();
    }

    public async uploadPdf(event?: any, input?: any) {
        this.preventUploadButtonDefault(event);
        if (!this.canUploadApplicant()) {
            await this.service.modal.error("지원자 PDF 업로드 권한이 필요합니다.");
            return;
        }
        const file = this.currentSelectedFile();
        if (!file) {
            this.selectedFile = null;
            this.clearFileInput(input);
            this.uploadState = "failed";
            this.uploadMessage = "PDF 파일을 선택해주세요.";
            this.uploadProgress = 0;
            await this.service.modal.error("PDF 파일을 선택해주세요.");
            await this.service.render();
            return;
        }
        const validationError = this.validateClientFile(file);
        if (validationError) {
            this.uploadState = "failed";
            this.uploadMessage = validationError;
            this.selectedFile = null;
            this.clearFileInput(input);
            await this.service.modal.error(validationError);
            await this.service.render();
            return;
        }

        this.uploading = true;
        this.uploadState = "processing";
        this.uploadMessage = "파일 검증 중입니다.";
        this.openUploadProgressModal(file);
        this.setUploadStep("파일 검증 중", 5);
        await this.service.render();
        await this.advanceUploadStep("업로드 중", 10);

        const fd = new FormData();
        fd.append("recruitment_id", this.search.recruitment_id);
        fd.append("file[]", file, file.name);
        const uploadUrl = `${wiz.url("upload")}?recruitment_id=${encodeURIComponent(this.search.recruitment_id)}`;
        let raw: any = null;
        try {
            raw = await this.service.file.upload(uploadUrl, fd, async (percent: number) => {
                this.uploadByteProgress = Math.max(0, Math.min(100, Math.round(Number(percent || 0))));
                this.uploadProgress = Math.min(60, 10 + Math.round(this.uploadByteProgress * 0.5));
                this.uploadStageLabel = "업로드 중";
                this.uploadMessage = `업로드 중입니다. ${this.uploadByteProgress}%`;
                await this.service.render();
            });
        } catch (error) {
            this.uploading = false;
            this.uploadState = "failed";
            this.uploadMessage = this.safeErrorMessage(error);
            this.failUploadProgress(this.uploadMessage);
            await this.service.render();
            return;
        }
        await this.advanceUploadStep("서버 저장 중", 70);
        const { code, data, message } = this.normalizeApiResult(raw);

        if (code === 200 && data?.ok !== false) {
            await this.advanceUploadStep("문서 처리 중", 80);
            await this.advanceUploadStep("텍스트 추출 중", 86);
            await this.advanceUploadStep("문서 분류 중", 92);
            await this.advanceUploadStep("검토 정보 준비 중", 96);
            this.uploadState = data?.status || "completed";
            this.uploadMessage = data?.message || "PDF 업로드와 페이지 텍스트 추출/분류가 완료되었습니다.";
            this.selectedFile = null;
            this.clearFileInput(input);
            await this.load();
            this.completeUploadProgress(this.uploadMessage);
            await this.service.render();
        } else {
            this.uploading = false;
            this.uploadState = "failed";
            this.uploadMessage = this.safeErrorMessage({ message, data });
            if (data?.uploaded_file) {
                this.selectedFile = null;
                this.clearFileInput(input);
            }
            if (data?.applicant || data?.applicant_id) await this.load();
            this.failUploadProgress(this.uploadMessage);
            await this.service.render();
        }
    }

    public async queueUpload() {
        await this.uploadPdf();
    }

    public firstFile(files: any) {
        if (!files || !files.length) return null;
        if (typeof files.item === "function") return files.item(0);
        return files[0] || null;
    }

    public fileCount(files: any) {
        return files?.length || 0;
    }

    public rejectMultipleFiles(files: any, input?: any) {
        if (this.fileCount(files) <= 1) return false;
        this.selectedFile = null;
        this.uploadState = "failed";
        this.uploadMessage = "PDF 1개만 업로드할 수 있습니다.";
        this.uploadProgress = 0;
        this.uploadByteProgress = 0;
        this.clearFileInput(input);
        return true;
    }

    public isUploadFile(file: any) {
        return !!file
            && typeof file.name === "string"
            && typeof file.size === "number"
            && typeof file.slice === "function";
    }

    public currentSelectedFile() {
        return this.isUploadFile(this.selectedFile) ? this.selectedFile : null;
    }

    public hasSelectedFile() {
        return !!this.currentSelectedFile();
    }

    public selectedFileName() {
        const file = this.currentSelectedFile();
        return file ? file.name : "통합 PDF 1개를 선택하거나 드래그하세요";
    }

    public selectedFileDetail() {
        const file = this.currentSelectedFile();
        if (!file && this.uploadState === "failed" && this.uploadMessage) return this.uploadMessage;
        if (!file) return `통합 PDF 1개만 업로드할 수 있습니다. · 최대 ${this.uploadMaxLabel()}`;
        return `${this.formatBytes(file.size)} · 업로드 준비`;
    }

    public openUploadProgressModal(file: any) {
        this.uploadModalOpen = true;
        this.uploadModalCanClose = false;
        this.uploadModalError = "";
        this.uploadModalFileName = file?.name || "";
        this.uploadModalFileSize = this.formatBytes(file?.size || 0);
        this.uploadByteProgress = 0;
    }

    public setUploadStep(label: string, progress: number) {
        this.uploadStageLabel = label;
        this.uploadProgress = Math.max(0, Math.min(100, Math.round(progress || 0)));
        this.uploadMessage = label;
    }

    public async advanceUploadStep(label: string, progress: number) {
        this.setUploadStep(label, progress);
        await this.service.render();
    }

    public completeUploadProgress(message: string) {
        this.uploading = false;
        this.uploadModalCanClose = true;
        this.uploadModalError = "";
        this.uploadStageLabel = "완료";
        this.uploadProgress = 100;
        this.uploadByteProgress = 100;
        this.uploadState = "completed";
        this.uploadMessage = message || "PDF 업로드와 검토 정보 준비가 완료되었습니다.";
    }

    public failUploadProgress(message: string) {
        this.uploading = false;
        this.uploadModalCanClose = true;
        this.uploadStageLabel = "실패";
        this.uploadProgress = this.uploadProgress || 0;
        this.uploadState = "failed";
        this.uploadModalError = this.safeErrorMessage({ message });
        this.uploadMessage = this.uploadModalError;
    }

    public closeUploadModal() {
        if (this.uploading && !this.uploadModalCanClose) return;
        this.uploadModalOpen = false;
    }

    public async retryUploadFromModal() {
        if (this.uploading || !this.hasSelectedFile()) return;
        await this.uploadPdf();
    }

    public uploadModalCloseLabel() {
        if (this.uploading && !this.uploadModalCanClose) return "처리 중";
        return this.uploadState === "completed" ? "닫기" : "닫기";
    }

    public uploadSteps() {
        return [
            "파일 검증 중",
            "업로드 중",
            "서버 저장 중",
            "문서 처리 중",
            "텍스트 추출 중",
            "문서 분류 중",
            "검토 정보 준비 중",
            "완료",
        ];
    }

    public uploadStepIndex(label?: string) {
        const index = this.uploadSteps().indexOf(label || this.uploadStageLabel);
        return index < 0 ? 0 : index;
    }

    public uploadStepClass(step: string) {
        if (this.uploadState === "failed" && step === this.uploadStageLabel) return "border-rose-200 bg-rose-50 text-rose-700";
        const active = this.uploadStepIndex();
        const index = this.uploadStepIndex(step);
        if (index < active || this.uploadState === "completed") return "border-emerald-200 bg-emerald-50 text-emerald-700";
        if (index === active) return "border-sky-200 bg-sky-50 text-sky-700";
        return "border-zinc-200 bg-white text-zinc-500";
    }

    public uploadMaxBytes() {
        return Number(this.uploadPolicy?.max_upload_bytes || this.uploadPolicy?.max_bytes || 100 * 1024 * 1024);
    }

    public uploadMaxLabel() {
        const maxUploadMb = Number(this.uploadPolicy?.max_upload_mb || 0);
        if (maxUploadMb > 0) return `${maxUploadMb}MB`;
        return this.formatBytes(this.uploadMaxBytes());
    }

    public soloAdminMode() {
        const policy = this.uploadPolicy || {};
        if (policy.ui_policy && policy.ui_policy.solo_admin_mode !== undefined) {
            return !!policy.ui_policy.solo_admin_mode;
        }
        if (policy.solo_admin_mode !== undefined) return !!policy.solo_admin_mode;
        return true;
    }

    public compactStatusLabel(label: string) {
        if (!this.soloAdminMode()) return label || "";
        const text = label || "";
        if (text.indexOf("권한") >= 0) return text;
        if (text.indexOf("확정 필요") >= 0 || text.indexOf("확인 필요") >= 0 || text.indexOf("수동검토") >= 0 || text.indexOf("입력 필요") >= 0) return "확인 필요";
        if (text.indexOf("자동 산정 초안") >= 0) return "초안";
        if (text.indexOf("미확정") >= 0) return "미확정";
        return text;
    }

    public listAttentionSummary(item: any) {
        const formErrors = Number(item?.form_summary?.form_error_candidates || 0);
        const disqualifications = Number(item?.form_summary?.disqualification_candidates || 0);
        const eligibilityNeedsReview = Number(item?.form_summary?.eligibility_needs_review || 0);
        const scoreNeedsReview = Number(item?.score_summary?.qualitative_pending_count || 0);
        const retentionNeedsReview = this.isAttentionStatus(item?.retention_summary?.status) ? 1 : 0;
        const count = formErrors + disqualifications + eligibilityNeedsReview + scoreNeedsReview + retentionNeedsReview;
        return {
            count,
            status: count > 0 ? "NEEDS_REVIEW" : "available",
            label: count > 0 ? `확인 필요 ${count}건` : "확인 완료",
            detail: `양식 ${formErrors} · 결격 ${disqualifications} · 평가 ${scoreNeedsReview}`
        };
    }

    public isAttentionStatus(status: string) {
        return [
            "NEEDS_REVIEW",
            "NEEDS_HUMAN_REVIEW",
            "MANUAL_REVIEW_REQUIRED",
            "MANUAL_CHECK_REQUIRED",
            "REVIEWER_REQUIRED",
            "NEEDS_ADMIN_CONFIRMATION",
            "APPROVAL_REQUESTED",
            "PENDING",
            "ON_HOLD",
        ].indexOf(status || "") >= 0;
    }

    public scoreSummaryLabel(item: any) {
        return `점수 ${item?.score_summary?.auto_total_label || 0}`;
    }

    public clearFileInput(input?: any) {
        if (input) input.value = "";
    }

    public preventUploadButtonDefault(event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
    }

    public validateClientFile(file: any) {
        const name = (file?.name || "").toLowerCase();
        const extOk = (this.uploadPolicy.allowed_extensions || [".pdf"]).some((ext: string) => name.endsWith(ext));
        if (!extOk) return "PDF 확장자 파일만 업로드할 수 있습니다.";
        const allowedMime = this.uploadPolicy.allowed_mime_types || ["application/pdf"];
        if (file.type && allowedMime.indexOf(file.type) < 0) return "PDF MIME 타입 파일만 업로드할 수 있습니다.";
        if (file.size <= 0) return "빈 파일은 업로드할 수 없습니다.";
        if (file.size > this.uploadMaxBytes()) return `파일 크기는 ${this.uploadMaxLabel()} 이하만 허용됩니다.`;
        return "";
    }

    public normalizeApiResult(res: any) {
        if (!res) return { code: 500, data: null, message: "응답을 확인할 수 없습니다." };
        let payload = res;
        if (typeof res === "string") payload = this.parseJson(res) || res;
        if (res.responseJSON) payload = res.responseJSON;
        if (res.responseText && !res.responseJSON) payload = this.parseJson(res.responseText) || payload;
        if (payload?.code) {
            const data = payload.data === undefined ? null : payload.data;
            return {
                code: payload.code,
                data,
                message: this.safeErrorMessage({ message: payload.message, data }, "")
            };
        }
        if (res.status && res.status !== 200) {
            const data = payload?.data || null;
            return {
                code: res.status,
                data,
                message: this.safeErrorMessage({ data, response: payload, error: res.error, responseText: res.responseText })
            };
        }
        return { code: 200, data: payload, message: this.safeErrorMessage(payload, "") };
    }

    public parseJson(value: any) {
        if (!value || typeof value !== "string") return null;
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }

    public safeErrorMessage(error: any, fallback: string = "PDF 업로드에 실패했습니다. 파일 형식과 용량을 확인하세요.") {
        const candidates = [
            error?.message,
            error?.data?.message,
            error?.response?.message,
            error?.error,
            error?.responseJSON?.data?.message,
            error?.responseJSON?.message,
            error?.responseText,
        ];
        for (const candidate of candidates) {
            const text = this.errorText(candidate);
            if (text) return text;
        }
        return fallback;
    }

    public errorText(value: any) {
        if (!value) return "";
        if (typeof value === "object") {
            return this.errorText(value.message || value.error || value.data?.message || "");
        }
        const text = String(value).trim();
        const parsed = this.parseJson(text);
        if (parsed && typeof parsed === "object") return this.errorText(parsed);
        if (!text || text === "[object Object]" || text === "Object Object") return "";
        if (/Traceback|File \"|\/opt\/|storage_key|file_path|applicant_pdf|\.py\b|<html/i.test(text)) return "";
        return text.length > 180 ? `${text.slice(0, 180).trim()}...` : text;
    }

    public formatBytes(size: number) {
        if (size >= 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
        if (size >= 1024) return `${(size / 1024).toFixed(1)} KB`;
        return `${size || 0} B`;
    }

    public badgeClass(status: string) {
        status = status || "";
        if (status === 'FAIL_CANDIDATE' || status === 'MISSING_EVIDENCE' || status === 'MISMATCH' || status === 'FAILED') return 'bg-rose-50 text-rose-700 border border-rose-200';
        if (status === 'PERMISSION_REQUIRED') return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
        if (status === 'NEEDS_REVIEW' || status === 'NEEDS_HUMAN_REVIEW' || status === 'MANUAL_REVIEW_REQUIRED' || status === 'MANUAL_CHECK_REQUIRED' || status === 'REVIEWER_REQUIRED' || status === 'LOW_CONFIDENCE' || status === 'MULTIPLE_CANDIDATES' || status === 'EMPTY_TEXT_LAYER' || status === 'UNREADABLE' || status === 'PARTIAL_MATCH' || status === 'INSUFFICIENT_EVIDENCE' || status === 'NEEDS_ADMIN_CONFIRMATION' || status === 'APPROVAL_REQUESTED') return 'bg-amber-50 text-amber-700 border border-amber-200';
        if (status === 'REVIEW_COMPLETED' || status === 'MATCHED' || status === 'PASS' || status === 'PASS_CANDIDATE' || status === 'CLASSIFIED' || status === 'EXTRACTED' || status === 'available') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'PROCESSING' || status === 'QUEUED' || status === 'processing' || status === 'queued') return 'bg-sky-50 text-sky-700 border border-sky-200';
        if (status === 'COMPLETED' || status === 'completed') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'FAILED' || status === 'failed') return 'bg-rose-50 text-rose-700 border border-rose-200';
        if (status === 'disabled') return 'bg-zinc-50 text-zinc-500 border border-zinc-200';
        return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
    }
}

export default PageApplicantsComponent;